import { GsFormIfArgValue, GsFormIfOperator } from 'libs/shared/src/components';

export function schemaNumberCompare(arg: GsFormIfArgValue, value: number | null | undefined, operator: GsFormIfOperator): boolean {
  if (!operator) operator = '==';
  switch (operator) {
    case '==': {
      return compareEqual(arg, value);
    }
    case '!=': {
      return compareNotEqual(arg, value);
    }
    case '<': {
      return compareLessThan(arg, value);
    }
    case '>': {
      return compareGreaterThan(arg, value);
    }
    case '<=': {
      return compareLessThan(arg, value) || compareEqual(arg, value);
    }
    case '>=': {
      return compareGreaterThan(arg, value) || compareEqual(arg, value);
    }
    default: {
      return false;
    }
  }
}

function compareEqual(val0: GsFormIfArgValue, val1?: number | null): boolean {
  if (val0 === undefined || val0 === null) return val1 === undefined || val1 === null || val1 === 0;
  switch (typeof val0) {
    case 'number':
      return val1 === val0;
    case 'string':
      return val1 === Number(val0);
    case 'boolean':
      return compareBoolean(val0, val1);
    case 'object':
      if (Array.isArray(val0)) return val0.some((val) => schemaNumberCompare(val, val1, '=='));
      break;
    default:
      console.debug(`[SchemaService] Unsupported value type for number comparison: ${typeof val0}`);
      return val1 == Number(val0);
  }
  return false;
}

function compareNotEqual(val0: GsFormIfArgValue, val1?: number | null): boolean {
  if (val0 === undefined || val0 === null) return val1 !== undefined && val1 !== null && val1 !== 0;
  switch (typeof val0) {
    case 'number':
      return val1 != val0;
    case 'string':
      return val1 != Number(val0);
    case 'boolean':
      return !compareBoolean(val0, val1);
    case 'object':
      if (Array.isArray(val0)) return val0.some((val) => schemaNumberCompare(val, val1, '!='));
      break;
    default:
      console.debug(`[SchemaService] Unsupported value type for number comparison: ${typeof val0}`);
      return val1 != Number(val0);
  }
  return false;
}

function compareLessThan(val0: GsFormIfArgValue, val1?: number | null): boolean {
  if (val0 === undefined || val0 === null) return val1 != null && val1 > 0;
  switch (typeof val0) {
    case 'number':
      return val1 != null && val1 > val0;
    case 'string':
      return val1 != null && val1 > Number(val0);
    case 'boolean':
      return !compareBoolean(val0, val1);
    case 'object':
      if (Array.isArray(val0)) return val0.some((val) => schemaNumberCompare(val, val1, '<'));
      break;
    default:
      console.debug(`[SchemaService] Unsupported value type for number comparison: ${typeof val0}`);
      return val1 ? Number(val0) < val1 : false;
  }
  return false;
}

function compareGreaterThan(val0: GsFormIfArgValue, val1?: number | null): boolean {
  if (val0 === undefined || val0 === null) return val1 != null && val1 < 0;
  switch (typeof val0) {
    case 'number':
      return val1 != null && val1 < val0;
    case 'string':
      return val1 != null && val1 < Number(val0);
    case 'boolean':
      return compareBoolean(val0, val1);
    case 'object':
      if (Array.isArray(val0)) return val0.some((val) => schemaNumberCompare(val, val1, '>'));
      break;
    default:
      console.debug(`[SchemaService] Unsupported value type for number comparison: ${typeof val0}`);
      return val1 ? Number(val0) > val1 : false;
  }
  return false;
}

function compareBoolean(val0: boolean, val1?: number | null): boolean {
  if (val0 === true) return !!val1 && val1 != 0;
  if (val0 === false) return !val1 || val1 === 0;
  return val0 === !!val1;
}
